import { useMemo } from "react";
import { BetSlipMode } from "../types/enums";

interface UseCalculateMaxPayoutProps {
  selections: IBetSlipSelection[];
  stakes: { [key: string]: number };
  mode: string;
  totalOdds: number;
  totalTaxValue: number;
  winBoostAmount: number;
  isFreeBetActive: boolean;
}

export const useCalculateMaxPayout = ({
  selections,
  stakes,
  mode,
  totalOdds,
  totalTaxValue,
  winBoostAmount,
  isFreeBetActive,
}: UseCalculateMaxPayoutProps) => {
  return useMemo(() => {
    if (mode === BetSlipMode.Single) {
      const totalPayout = selections.reduce((sum, selection) => {
        const stake = (stakes[selection.key] as number) || 0;
        // Free bet: only winnings paid out (stake not returned) → stake × (odds − 1)
        const gross = isFreeBetActive
          ? stake * selection.oddPrice - stake
          : stake * selection.oddPrice;
        return sum + gross;
      }, 0);
      return totalPayout + totalTaxValue + winBoostAmount;
    } else {
      const comboNetStake = (stakes[BetSlipMode.Combo] as number) || 0;
      // Free bet: only winnings paid out (stake not returned) → stake × (odds − 1)
      const grossPayout = isFreeBetActive
        ? comboNetStake * totalOdds - comboNetStake
        : comboNetStake * totalOdds;
      return grossPayout + totalTaxValue + winBoostAmount;
    }
  }, [
    selections,
    stakes,
    mode,
    totalOdds,
    totalTaxValue,
    winBoostAmount,
    isFreeBetActive,
  ]);
};
